export const cancellationReasons = [
    {
        label: "Unacceptable due to Mid - Term Adjustment",
        code: "A"
    },
    {
        label: "Cancelled NTU",
        code: "B"
    },
    {
        label: "Non - Disclosure of Material Fact",
        code: "C"
    },
    {
        label: "Non - Receipt of Documents",
        code: "D"
    },
    {
        label: "Non - Payment of Premium",
        code: "E"
    },
    {
        label: "Non - Payment of Insurer DDM",
        code: "F"
    },
    {
        label: "Sale of Vehicle",
        code: "G"
    },
    {
        label: "Total Loss Claim",
        code: "H"
    },
    {
        label: "Misquote",
        code: "I"
    },
    {
        label: "Dispute / Complaint",
        code: "J"
    },
    {
        label: "Emigration",
        code: "K"
    },
    {
        label: "III Health of Policyholder",
        code: "L"
    },
    {
        label: "Death of Policyholder",
        code: "M"
    },
    {
        label: "Due to Free Insurance",
        code: "N"
    },
    {
        label: "Cooling Off",
        code: "O"
    },
    {
        label: "Alternative Insurance",
        code: "P"
    },
]

const GetCancellationReason = (code: string) => {
    return cancellationReasons.find((cr) => cr.code === code)
}

export default GetCancellationReason